<template>
  <div :class="wrapperContainerClass">
    <h3 class="mt-0">{{ title }}</h3>
    <div :class="wrapperClass">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: { type: String, required: true },
  singleItem: { type: Boolean, default: false },
  noMargin: { type: Boolean, default: false },
});

const wrapperContainerClass = computed(() => ["bg-white", "pa-30px", "br-10px", props.noMargin ? "" : "mt-30px"]);
const wrapperClass = computed(() => ["dashboard-items", props.singleItem ? "" : "d--f"]);
</script>

<style lang="scss" scoped>
.dashboard-items {
  gap: 20px;
  flex-wrap: wrap;
}
</style>
